<template>
    <div class="page select-modal">
        <div class="vertical-flow">
            <div class="listing-header">
                <div class="title-breadcrumb">
                    <h1 class="title">
                        {{ $t("cliente") }}
                        <a
                            class="pl-1"
                            v-if="hide.hideInfo"
                            @click="infoIsHidden()"
                        >
                            <b-icon
                                v-if="!hide.infoIsHidden"
                                icon="eye-off-outline"
                                type="is-danger"
                            />
                            <b-icon
                                v-if="hide.infoIsHidden"
                                icon="eye-outline"
                                type="is-success"
                            />
                        </a>
                    </h1>
                    <nav class="breadcrumb" aria-label="breadcrumbs">
                        <ul>
                            <li>
                                <a class="a-inativo">{{
                                    isVenda ? $t('vendas') : $t('agro')
                                }}</a>
                            </li>
                            <li>
                                <a
                                    @click="
                                        $router.push({
                                            name: `${abrev}-cliente-list`,
                                        })
                                    "
                                    >{{ $t("clientes") }}</a
                                >
                            </li>
                            <li>
                                <a aria-current="page">{{
                                    $route.params.id
                                        ? `${$route.params.id} - ${loadingName ? $t("carregando") : name}`
                                        : $t("novo")
                                }}</a>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div class="header-buttons">
                    <button
                        class="delete-btn"
                        type="button"
                        tag="button"
                        @click="$router.push({ name: `${abrev}-cliente-list` })"
                    >
                        {{ $t("voltar") }}
                    </button>
                </div>
            </div>

            <ul class="nav nav-tabs nav-tabs-main">
                <router-link
                    v-if="isUpdate && permissaoDadosCadastrais.read"
                    tag="li"
                    :to="{
                        name: `${abrev}-cliente-dados-cadastrais-${
                            isUpdate ? 'edit' : 'new'
                        }`,
                        params: {
                            id: $route.params.id,
                        },
                        query: {
                            dadoscadastrais: $route.query.dadoscadastrais 
                                ? $route.query.dadoscadastrais
                                : null,
                            politicacomercial: abaSelecionada,
                            analisecomercial: $route.query.analisecomercial
                                ? $route.query.analisecomercial
                                : null
                        }
                    }"
                >
                    <a>{{ $t("dados-cadastrais") }}</a>
                </router-link>
                <router-link
                    tag="li"
                    :to="{
                        name: `${abrev}-cliente-politica-comercial-${
                            isUpdate ? 'edit' : 'new'
                        }`,
                        params: {
                            id: $route.params.id,
                            name: $route.params.name,
                        },
                    }"
                >
                    <a>{{ $t("politica-comercial") }}</a>
                </router-link>
                <router-link
                    v-if="isUpdate && permissaoAnaliseComercial.read"
                    tag="li"
                    :to="{
                        name: `${abrev}-cliente-analise-comercial-${
                            isUpdate ? 'edit' : 'new'
                        }`,
                        params: {
                            id: $route.params.id,
                            name: $route.params.name,
                        },
                        query: {
                            dadoscadastrais: $route.query.dadoscadastrais 
                                ? $route.query.dadoscadastrais
                                : null,
                            politicacomercial: abaSelecionada,
                            analisecomercial: $route.query.analisecomercial
                                ? $route.query.analisecomercial
                                : null
                        }
                    }"
                >
                    <a>{{ $t("analise-comercial") }}</a>
                </router-link>
            </ul>

            <ul class="nav nav-tabs nav-tabs-children">
                <li
                    v-for="(aba, i) in abas"
                    :key="i"
                    v-show="listaPermissoes[aba].read"
                    :class="{ active: abaSelecionada == i }"
                    @click="changeTab(i)"
                >
                    <a data-toggle="tab">{{ $t(aba) }}</a>
                </li>
            </ul>

            <!-- CONJTO DE ABAS - MOBILE -->
            <b-dropdown aria-role="list" class="mobile-tab-list">
                <div slot="trigger" class="mobile-tab">
                    <span class="mobile-tab-text">
                        {{ $t(abas[abaSelecionada]) }}
                    </span>
                    <em class="mdi mdi-chevron-down"></em>
                </div>

                <b-dropdown-item
                    class="mobile-tab-list-item"
                    :class="{ active: abaSelecionada == i }"
                    aria-role="listitem"
                    v-for="(aba, i) in abas"
                    v-show="listaPermissoes[aba].read"
                    :key="i"
                    @click="changeTab(i)"
                >
                    {{ $t(aba) }}
                </b-dropdown-item>
            </b-dropdown>

            <!-- PRAZO PAGAMENTO -->
            <PrazoPagamento
                ref="tabPrazoPagamento"
                v-if="
                    abasAbertas['prazo-pagamento'] &&
                    listaPermissoes['prazo-pagamento'].read &&
                    isUpdate
                "
                v-show="abas[abaSelecionada] == 'prazo-pagamento'"
                :isUpdate="isUpdate"
            />

            <!-- FORMA PAGAMENTO -->
            <FormaPagamento
                ref="tabFormaPagamento"
                v-if="
                    abasAbertas['forma-pagamento'] &&
                    listaPermissoes['forma-pagamento'].read &&
                    isUpdate
                "
                v-show="abas[abaSelecionada] == 'forma-pagamento'"
                :isUpdate="isUpdate"
            />

            <!-- CAMPANHA -->
            <Campanha
                ref="tabCampanha"
                v-if="
                    abasAbertas['campanha'] &&
                    listaPermissoes['campanha'].read &&
                    isUpdate
                "
                v-show="abas[abaSelecionada] == 'campanha'"
                :isUpdate="isUpdate"
            />

            <!-- TABELA PRECO -->
            <TabelaPreco
                ref="tabTabelaPreco"
                v-if="
                    abasAbertas['tabela-preco'] &&
                    listaPermissoes['tabela-preco'].read &&
                    isUpdate
                "
                v-show="abas[abaSelecionada] == 'tabela-preco'"
                :isUpdate="isUpdate"
            />

            <!-- FORMA RECEBIMENTO -->
            <FormaRecebimento
                ref="tabFormaRecebimento"
                v-if="
                    abasAbertas['forma-recebimento'] &&
                    listaPermissoes['forma-recebimento'].read &&
                    isUpdate
                "
                v-show="abas[abaSelecionada] == 'forma-recebimento'"
                :isUpdate="isUpdate"
            />

            <!-- DESCONTO POR QUANTIDADE -->
            <DescontoQuantidade
                ref="tabDescontoQuantidade"
                v-if="
                    abasAbertas['desconto-qtde'] &&
                    listaPermissoes['desconto-qtde'].read &&
                    isUpdate
                "
                v-show="abas[abaSelecionada] == 'desconto-qtde'"
                :isUpdate="isUpdate"
            />

            <!-- TIPO DE PEDIDO -->
            <TipoPedido
                ref="tabTipoPedido"
                v-if="
                    abasAbertas['tipo-pedido'] &&
                    listaPermissoes['tipo-pedido'].read &&
                    isUpdate
                "
                v-show="abas[abaSelecionada] == 'tipo-pedido'"
                :isUpdate="isUpdate"
            />

            <!-- LIMITE DE CREDITO -->
            <LimiteCredito
                ref="tabLimiteCredito"
                v-if="
                    abasAbertas['limite-credito'] &&
                    listaPermissoes['limite-credito'].read &&
                    isUpdate
                "
                v-show="abas[abaSelecionada] == 'limite-credito'"
                :isUpdate="isUpdate"
            />

            <!-- FINANCEIRO -->
            <Financeiro
                ref="tabFinanceiro"
                v-if="
                    abasAbertas['financeiro'] &&
                    listaPermissoes['financeiro'].read &&
                    isUpdate
                "
                v-show="abas[abaSelecionada] == 'financeiro'"
                @isChanged="isChanged = $event"
                :isUpdate="isUpdate"
            />
            <!-- FORNECEDOR RESTRICAO -->
            <RestricaoFornecedor
                ref="tabRestricaoFornecedor"
                v-if="
                    abasAbertas['fornecedor-restricao'] &&
                    listaPermissoes['fornecedor-restricao'].read
                "
                v-show="abas[abaSelecionada] == 'fornecedor-restricao'"
                :isUpdate="isUpdate"
            />
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import ClienteService from "@/services/vendas/cliente/ClienteService";

// Abas
import PrazoPagamento from "@/components/vendas/cliente/abas/politica-comercial/PrazoPagamento";
import FormaPagamento from "@/components/vendas/cliente/abas/politica-comercial/FormaPagamento";
import Campanha from "@/components/vendas/cliente/abas/politica-comercial/Campanha";
import TabelaPreco from "@/components/vendas/cliente/abas/politica-comercial/TabelaPreco";
import FormaRecebimento from "@/components/vendas/cliente/abas/politica-comercial/FormaRecebimento";
import DescontoQuantidade from "@/components/vendas/cliente/abas/politica-comercial/DescontoQuantidade";
import TipoPedido from "@/components/vendas/cliente/abas/politica-comercial/TipoPedido";
import LimiteCredito from "@/components/vendas/cliente/abas/politica-comercial/LimiteCredito";
import Financeiro from "@/components/vendas/cliente/abas/politica-comercial/Financeiro";
import RestricaoFornecedor from "@/components/vendas/cliente/abas/politica-comercial/FornecedorRestricao";

export default {
    beforeRouteLeave(to, from, next) {
        if (this.isChanged) {
            this.promptChangeTab(next);
        } else {
            next();
        }
    },
    components: {
        PrazoPagamento,
        FormaPagamento,
        Campanha,
        TabelaPreco,
        FormaRecebimento,
        DescontoQuantidade,
        TipoPedido,
        LimiteCredito,
        Financeiro,
        RestricaoFornecedor,
    },
    data() {
        return {
            id: 0,
            abaSelecionada: 0,
            // Seguir nome na tabela app_tela e usar estes nomes no dicionário para criação dinâmica de listaPermissoes e abasAbertas
            abas: [
                "prazo-pagamento",
                "forma-pagamento",
                "campanha",
                "tabela-preco",
                "forma-recebimento",
                "desconto-qtde",
                "tipo-pedido",
                "limite-credito",
                "financeiro",
                "fornecedor-restricao",
            ],
            abasAbertas: {},
            permissaoDadosCadastrais: false,
            permissaoAnaliseComercial: false,
            permissaoPoliticaComercial: false,
            listaPermissoes: {},
            isUpdate: false,
            isChanged: false,
            name: null,
            loadingName: false,
            serviceCliente: new ClienteService(this.$http, this.$router),
            // @86308 - Rota dinâmica abreviando o contexto
            abrev: this.$route.meta.contexto.slice(0,3),
            isVenda: this.$route.meta.contexto == "vendas",
            isAgro: this.$route.meta.contexto == "agro",
        };
    },
    mounted() {
        // @85391 - Descontinuado uso da query abaSelecionada em telas que possuem aba e sub-abas
        // if (this.$route.query.abaSelecionada) {
        //     this.changeTab(this.abas.indexOf(this.$route.query.abaSelecionada));
        // } else 
        if (this.$route.query.politicacomercial && this.$route.params.id) {
            this.changeTab(this.$route.query.politicacomercial < this.abas.length 
                ? this.$route.query.politicacomercial
                : 0
            );
        }
    },
    created() {
        this.id = this.$route.params.id;

        if (this.$route.params.id) this.isUpdate = true;

        if (this.isVenda) {
            this.permissaoPoliticaComercial = this.hasPermissionAccess(
                "vendas",
                "clientes",
                "ven-cliente-politica-comercial"
            );
        }else if (this.isAgro){
            this.abrev = this.$route.meta.contexto.slice(0,4);
            this.permissaoPoliticaComercial = this.hasPermissionAccess( 
                'agro', 
                'clientes', 
                'agro-cliente-politica-comercial');
        }

        if (
            (!this.isUpdate && !this.permissaoPoliticaComercial.create) ||
            (this.isUpdate && !this.permissaoPoliticaComercial.update) ||
            !this.permissaoPoliticaComercial.read
        ) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "clientes" },
            });
        } else {
            // Criação dinâmica de listaPermissoes e abasAbertas baseado no nome das tabs
            for (let [key, value] of Object.entries(this.abas)) {
                this.abasAbertas[value] = false;
                this.listaPermissoes[value] = this.hasPermissionAccess(
                    "vendas",
                    "clientes",
                    `ven-cliente-politica-comercial-${value}`
                );
                if (this.isVenda) {
                    this.listaPermissoes[value] = this.hasPermissionAccess(
                        "vendas",
                        "clientes",
                        `ven-cliente-politica-comercial-${value}`
                    );
                }else if (this.isAgro){
                    this.listaPermissoes[value] = this.hasPermissionAccess(
                    'agro', 
                    'clientes', 
                    `agro-cliente-politica-comercial-${value}`);
                }
            }

            if(this.isUpdate) this.loadName();

            if (this.isVenda) {
                this.permissaoDadosCadastrais = this.hasPermissionAccess(
                    "vendas",
                    "clientes",
                    'ven-cliente-dados-cadastrais'
                );
                this.permissaoAnaliseComercial = this.hasPermissionAccess(
                    "vendas",
                    "clientes",
                    'ven-cliente-analise-comercial'
                );
            }else if (this.isAgro) {
                this.permissaoDadosCadastrais = this.hasPermissionAccess(
                    'agro', 
                    'clientes', 
                    'agro-cliente-dados-cadastrais'
                );
                this.permissaoAnaliseComercial = this.hasPermissionAccess(
                    'agro', 
                    'clientes', 
                    'agro-cliente-analise-comercial'
                );
            }

            // Pegar dinâmicamente a primeira aba que estivar com permissão de leitura para a mesma iciciar visível
            for (let [key, value] of Object.entries(this.listaPermissoes)) {
                if (value.read) {
                    this.abaSelecionada = this.abas.findIndex((e) => e == key);
                    this.abasAbertas[key] = true;
                    break;
                }
            }
        }
    },
    computed: {
        ...mapState(["hide"]),
    },
    methods: {
        loadName() {
            this.loadingName = true;
            this.loadNamePC()
                .then((res) => {
                    this.name = res.content.nome;
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message("error", "msg-erro-load", true));
                })
                .finally((_) => {
                    this.loadingName = false;
                });
        },
        loadNamePC() {
            if (this.isVenda) return this.serviceCliente.loadNameVendas(this.$route.params.id);
            else return this.serviceCliente.loadNameAgro(this.$route.params.id);
        },
        infoIsHidden() {
            this.$store.dispatch("infoIsHidden", {
                infoIsHidden: !this.hide.infoIsHidden,
            });
        },
        changeTab(i) {
            this.abaSelecionada = i;
            this.abasAbertas[this.abas[this.abaSelecionada]] = true;
        },
        promptChangeTab(next) {
            this.$root.confirm({
                message: this.$t("msg-tem-certeza-alteracoes"),
                onConfirm: (_) => {
                    this.isChanged = false;
                    next();
                },
                onCancel: (_) => {
                    next(false);
                },
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.page {
    position: relative;
    padding-left: 0;
    .nav-tabs-main {
        margin-bottom: 10px;
    }
    .nav-tabs-children {
        margin-bottom: 20px;
        li > a {
            text-transform: capitalize;
        }
        li > ::after {
            bottom: -4px;
            border-width: 2px;
        }
    }

    .mobile-tab {
        cursor: pointer;

        &-list {
            width: calc(100% + 40px);
            margin-top: 20px;
            margin-bottom: 20px;
            margin-left: -20px;
            padding-right: 20px;
            padding-bottom: 5px;
            padding-left: 20px;
            border-bottom: 1px solid $table-border;
            justify-content: center;

            &::after {
                content: "";
                border: 3px solid $primary-color-click;
                border-radius: 100px;
                position: absolute;
                width: calc(100% - 40px);
                bottom: -3px;
            }

            &-item {
                text-transform: uppercase;
                font-weight: 600;
                color: $text-color;

                &.active {
                    color: $primary-color-click;
                }
            }
        }

        &-text {
            text-transform: uppercase;
            font-weight: 600;
            color: $primary-color-click;

            & ~ i {
                color: $primary-color-click;
            }
        }
    }
}

@media only screen and (max-width: 760px) {
    .nav.nav-tabs-main {
        display: flex;
        justify-content: center;
        padding: 0;
        margin: 0;

        &::after {
            display: none;
        }
    }

    .nav.nav-tabs.nav-tabs-children {
        display: none;
    }
}

@media only screen and (min-width: 761px) {
    .mobile-tab-list {
        display: none;
    }
}
</style>
